import React from 'react'
import { Loader, Text } from '@components/UI'
import { Classroom as ClassroomConstants } from '@constants'
import { useClassroomEnv } from '@components/ClassroomEnv'

const Initializer = () => {
  const { env } = useClassroomEnv()

  const getLoadingMessage = () => {
    switch (env) {
      case ClassroomConstants.ENV.PLAYGROUND:
        return 'Loading the playground...'
      case ClassroomConstants.ENV.CLASSROOM:
        return 'Joining to the classroom...'
      case ClassroomConstants.ENV.RECORDING:
        return 'Preparing the recording...'
      case ClassroomConstants.ENV.SKETCHPAD:
        return 'Preparing the sketchpad...'
      default:
        return null
    }
  }
  return (
    <Loader full icon style={{ flexDirection: 'column' }}>
      <Text className='text-c' style={{ marginTop: '12px', opacity: 0.9 }}>
        {getLoadingMessage()}
      </Text>
    </Loader>
  )
}

export default Initializer
